import type { LegalAudience, LegalDocumentCode } from '@/constants/legal';

export function resolveLegalAudienceForInvitation(
  scopeCode: string,
  isOwner: boolean
): LegalAudience {
  if (scopeCode !== 'tenant') {
    return 'client';
  }
  return isOwner ? 'owner' : 'member';
}

export function resolveLegalAudienceForDocuments(
  documentCodes: LegalDocumentCode[]
): LegalAudience {
  if (documentCodes.includes('data_processing_agreement')) {
    return 'owner';
  }
  if (documentCodes.includes('terms_of_service')) {
    return 'member';
  }
  return 'client';
}
